/**
 * AMCパスワード入力画面
 *
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SupportModalIdComponent } from '@lib/components/support-class';
import { CommonLibService, PageInitService, PageLoadingService } from '@lib/services';
import { PasswordInputService } from './password-input.service';
import { GetBasicReservationInformationRequest } from 'src/sdk-amcmember';
import { GetBasicReservationInformationStoreService } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.service';
import { apiEventAll } from '@common/helper';
import { PageType } from '@lib/interfaces';

@Component({
  selector: 'asw-password-input',
  templateUrl: './password-input.component.html',
  providers: [PasswordInputService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordInputComponent extends SupportModalIdComponent {
  override autoInitEnd = false;
  constructor(
    private _common: CommonLibService,
    private _pageInitService: PageInitService,
    private _service: PasswordInputService,
    private _getBasicReservationInformationStoreService: GetBasicReservationInformationStoreService,
    private _pageLoadingService: PageLoadingService
  ) {
    super(_common, _pageInitService);
    this._common.aswCommonStoreService.updateAswCommon({
      subFunctionId: this.subFunctionId,
      subPageId: this.subPageId,
    });
  }

  init() {
    this.amcNumber = this._common.amcMemberStoreService.amcMemberData.amcNumber;
    if (this.amcNumber.length > 4) {
      this.amcNumber = '*'.repeat(this.amcNumber.length - 4) + this.amcNumber.substr(-4);
    }
    this._pageInitService.subDynamicInit(this.params);
    this._pageInitService.endInit(null);
  }
  destroy() {}
  reload() {}

  amcNumber: string = '';

  subPageId: string = 'M081';
  subFunctionId: string = 'R01';
  public password: string = '';
  public passwordFormControl = new FormControl();

  clickLogin() {
    this._pageLoadingService.startLoading();
    this.password = this.passwordFormControl.value;
    if (this._service.checkPassword(this.password)) {
      return;
    }
    //リクエストパラメータ作成
    const requestParameter: GetBasicReservationInformationRequest = {
      password: this.password,
    };
    // 予約基本情報取得API呼び出し
    apiEventAll(
      () => {
        this._service.getBasicReservationInformation(requestParameter);
      },
      this._getBasicReservationInformationStoreService.getGetBasicReservationInformation$(),
      () => {
        this._pageLoadingService.endLoading();
        this.close(true);
      },
      () => {
        this._pageLoadingService.endLoading();
        this._common.errorsHandlerService.setRetryableError(PageType.SUBPAGE, { errorMsgId: 'E0227' });
      }
    );
  }
}
